export default __webpack_public_path__ + "static/media/car6.dc4bdbea.jpg";